import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const rocheStageHomeTeaserCss = ":host{z-index:0;position:relative;overflow:hidden;display:flex;flex-direction:column;padding:3rem 0}@media (min-width: 48rem){:host{padding:4rem 0}}@media (min-width: 64rem){:host{padding:4rem 0}}@media (min-width: 90rem){:host{padding:6rem 0}}.title{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:1.875rem;line-height:2.25rem;width:100%}.title strong{font-weight:600}@media (min-width: 48rem){.title{font-size:2.5rem;line-height:3rem}}@media (min-width: 90rem){.title{font-size:3rem;line-height:3.625rem}}@media (min-width: 64rem){.title{width:83.3333333333%}}.description{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;width:100%;margin:0.5rem 0 2rem}@media (min-width: 64rem){.description{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}@media (min-width: 64rem){.description{width:83.3333333333%;margin:1rem 0 2.5rem}}@media (min-width: 90rem){.description{width:83.3333333333%;margin:1rem 0 3rem}}::slotted(roche-button){margin:auto 0 0}@media (min-width: 48rem){::slotted(roche-button){width:fit-content}}@media (hover: hover){:host::before,:host::after{z-index:-100;display:block;content:\"\";position:absolute;top:50%;height:calc(100% / 0.7547095802);width:0.0625rem;right:0;background:#9d948e;transform-origin:top;transition:transform 0.1s ease-in}:host::before{transform:rotate(-41deg) translateY(-50%) scale(0)}:host::after{transform:rotate(41deg) translateY(-50%) scale(0)}:host(.animation-playing)::before,:host(.animation-playing)::after{transition:transform 0.5s ease-in}:host(.animation-playing)::before{transform:rotate(-41deg) translateY(-50%) scale(1)}:host(.animation-playing)::after{transform:rotate(41deg) translateY(-50%) scale(1)}}";
const RocheStageHomeTeaserStyle0 = rocheStageHomeTeaserCss;

const RocheStageHomeTeaser$1 = /*@__PURE__*/ proxyCustomElement(class RocheStageHomeTeaser extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.teaserTitle = undefined;
        this.teaserDescription = undefined;
        this.animationPlaying = false;
    }
    toggleAnimation() {
        this.animationPlaying = !this.animationPlaying;
    }
    setupButtonEventHandlers() {
        const slot = this.element.shadowRoot.querySelector('slot');
        slot.assignedElements().forEach((button) => {
            ['mouseenter', 'mouseleave'].forEach((event) => button.addEventListener(event, () => this.toggleAnimation()));
        });
    }
    componentDidLoad() {
        this.setupButtonEventHandlers();
    }
    render() {
        return (h(Host, { key: 'f788b861956d01a01edd058acebe80f87f869bd4', class: { 'animation-playing': this.animationPlaying } }, h("div", { key: 'f9aa948a9c771cffa1eba485fab3aab887806814', class: 'title' }, this.teaserTitle), h("div", { key: '66a7433ee486692b00535b5137dcb13a78ecec3d', class: 'description' }, this.teaserDescription), h("slot", { key: 'd662e0f0fee02ca8fca33378b87bbee427e5a1e9', name: "button" })));
    }
    get element() { return this; }
    static get style() { return RocheStageHomeTeaserStyle0; }
}, [1, "roche-stage-home-teaser", {
        "teaserTitle": [1, "teaser-title"],
        "teaserDescription": [1, "teaser-description"],
        "animationPlaying": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-stage-home-teaser"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-stage-home-teaser":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheStageHomeTeaser$1);
            }
            break;
    } });
}

const RocheStageHomeTeaser = RocheStageHomeTeaser$1;
const defineCustomElement = defineCustomElement$1;

export { RocheStageHomeTeaser, defineCustomElement };

//# sourceMappingURL=roche-stage-home-teaser.js.map